export const STUDENT_DATA_REF_LIST = {
  iframe_ringle_doc: 'iframe_ringle_doc',
  btn_back: 'btn_back',
  btn_next: 'btn_next',
  btn_preview: 'btn_preview',
  btn_submit: 'btn_submit',
  btn_fluency: 'btn_fluency',
  btn_grammar: 'btn_grammar',
  btn_vocab: 'btn_vocab',
  btn_delete: 'btn_delete',
  btn_add_feedback: 'btn_add_feedback',
}
